import { Spacing } from '@persona-id/design-tokens';
import { FieldValues, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { BirthdateMatchType } from 'dashboard/models/report-template-version';
import Radio from 'design-system/components/Radio';
import RadioGroup from 'design-system/components/RadioGroup';
import Spacer from 'design-system/components/Spacer';
import { Span } from 'design-system/components/Text';
import { paragraphMixins } from 'design-system/mixins/text';
import { FontWeight } from 'design-system/variables/text';

const RadioLabelWrapper = styled.span`
  display: flex;
  flex-direction: column;
  margin-left: ${Spacing[2]};
`;

const RadioLabelTitle = styled(Span)`
  ${paragraphMixins.lgBold}
`;

const RadioLabelSubTitle = styled(Span)`
  ${paragraphMixins.md}
  font-weight: ${FontWeight.Regular};
`;

interface BirthdateMatchingFormData extends FieldValues {
  'birthdate-match-type': BirthdateMatchType;
}

interface BirthdateMatchingFormSectionProps {
  availableOptions?: BirthdateMatchType[];
  disabled: boolean;
}

export const BirthdateMatchingFormSection = ({
  availableOptions = Object.values(BirthdateMatchType),
  disabled,
}: BirthdateMatchingFormSectionProps) => {
  const { register } = useFormContext<BirthdateMatchingFormData>();
  return (
    <RadioGroup>
      {availableOptions.includes(BirthdateMatchType.DayExact) && (
        <>
          <Radio
            label={
              <RadioLabelWrapper>
                <RadioLabelTitle>Exact date</RadioLabelTitle>
                <Spacer height={0.5} />
                <RadioLabelSubTitle color='secondary'>
                  E.g. for input 12-25-2000, only 12-25-2000 will match
                </RadioLabelSubTitle>
              </RadioLabelWrapper>
            }
            {...register('birthdate-match-type')}
            value={BirthdateMatchType.DayExact}
            disabled={disabled}
          />
          <Spacer height={1.5} />
        </>
      )}

      {availableOptions.includes(BirthdateMatchType.YearExact) && (
        <>
          <Radio
            label={
              <RadioLabelWrapper>
                <RadioLabelTitle>Exact year</RadioLabelTitle>
                <Spacer height={0.5} />
                <RadioLabelSubTitle color='secondary'>
                  E.g. for input 12-25-2000, 01-10-2000 will match
                </RadioLabelSubTitle>
              </RadioLabelWrapper>
            }
            {...register('birthdate-match-type')}
            value={BirthdateMatchType.YearExact}
            disabled={disabled}
          />
          <Spacer height={1.5} />
        </>
      )}

      {availableOptions.includes(BirthdateMatchType.PlusOrMinusOneYear) && (
        <>
          <Radio
            label={
              <RadioLabelWrapper>
                <RadioLabelTitle>Within +/- 1 year (default)</RadioLabelTitle>
                <Spacer height={0.5} />
                <RadioLabelSubTitle color='secondary'>
                  E.g. for input 12-25-2000, 01-10-2001 and 12-25-1999 will match
                </RadioLabelSubTitle>
              </RadioLabelWrapper>
            }
            {...register('birthdate-match-type')}
            value={BirthdateMatchType.PlusOrMinusOneYear}
            disabled={disabled}
          />
        </>
      )}
    </RadioGroup>
  );
};
